export default __webpack_public_path__ + "static/media/Univers-Condensed.1203eb72.otf";